import { render, staticRenderFns } from "./MtEditor.vue?vue&type=template&id=22908a51&scoped=true&"
import script from "./MtEditor.vue?vue&type=script&lang=js&"
export * from "./MtEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22908a51",
  null
  
)

export default component.exports